export const language = {
  name: '中文'
};
export const nav = {
  home: 'Home',
  services: 'Solutions',
  company: 'About Us',
  platform: 'Apps',
  platformCustomer: 'Customers Login',
  platformSelf: 'Employees Login',
  contactus: 'Contact Us',
  news: 'News'
};
export const imgPath = {
  homeBanner: require('@/assets/en/banner.jpg'),
  home1: require('@/assets/en/home1.jpg'),
  home2: require('@/assets/en/home2.jpg'),
  home3: require('@/assets/en/home3.jpg'),
  banner2: require('@/assets/en/banner2.jpg'),
  img2: require('@/assets/en/img2.jpg'),
  vision: require('@/assets/en/vision.png'),
}
export const css = {
  imgBox: 'img-box-en',
  quality: 'quality quality-en',
  batter: 'batter batter-en',
  const_box_one: 'const_box_one const_box_one-en',
  const_box_two: 'const_box_two const_box_two-en'
}
export const common = {
  platformService: 'Platform Services',
  costReduction: 'Cost Reduction',
  managementEfficiency: 'Management Efficiency',
  qualityAssurance: 'Quality Assurance',
  aboutUs: 'About Us',
  companyProfile: 'Company Profile',
  awards: 'Awards',
  milestones: 'Milestones',
  news: 'News',
  ourActivities: 'Our activities',
  industry: 'Industry',
  phone: 'PHONE',
  address: 'Location',
  addressStr: 'Room 905, Dacheng Commercial Plaza, 1699 Gubei Road, Minhang District, Shanghai',
}
export const services = {
  title1: 'Cost Optimization',
  subtitle1: '3 core system management in cost reduction',
  title1_1_1: 'Packaging Design system',
  title1_1_2: 'Universal packaging compared with multi dimensional design helps customer with cost reduction.',
  text1_1: 'Adopting the stance from the customer’s perspective, incorporating internet technology amalgamating with traditional packaging to mold the final proposed packaging design. From demand to final output, all requirements can be met online with ease of speed and accuracy. By utilizing, and using the availability of data available in the system, design solution are efficiently generated in the possible shortest time at the lowest possible cost enabling further large scale production reducing the overall packaging cost while maintaining packaging quality.',
  title1_2_1: 'Efficient Operation Management Syatem',
  title1_2_2: 'Unique supply chain system that reduce cost',
  text1_2: 'Our supply chain system will automatically match and recommend the best factory to the needs of our customers upon evaluating the requirement of the customers( Customer address, delivery requirements, delivery cycle, etc.) satisfying the needs of our customers.',
  title1_3_1: 'Efficient Operation Management System',
  title1_3_2: 'System automation reduces operation cost',
  text1_3: 'From packaging design, PO and production up to quality management, the entire process and packaging materials are digitalized. The system will capture and digitalize every process to provide real time data. This is imperative in ensuring the reliability of proposed packaging design, production of packaging materials and operation efficiency, By adopting digitalization in every phase and process a sustain quality product meeting and satisfying the customer demand and criteria for their packaging needs will be achieved.',
  title2: 'Efficiency in Management',
  subtitle2: 'System management leads to higher efficiency in diverse departments',
  title2_1: 'Ease of Management',
  li2_1: 'Online Material Management System',
  li2_2: 'Visibility in PO and warehousing management',
  li2_3: 'Real time "push out" of digital supply chain data',
  li2_4: 'Data administrator',
  title3: 'Quality Assurance',
  subtitle3: 'Utilizing System to control and monitor consistency in product quality',
  title3_1: 'Packaging Database',
  text3_1: 'Packaging materials configuration, database are derived and culminated over the years providing a reliable sources of empirical data to support, and validate proposed packaging designs/solutions.',
  title3_2: 'BOM and management of packaging drawings',
  text3_2: 'Online material and database provides Bill of Material (BOM) and packaging drawings immediately, supporting real time changes and validating the reliability along with authenticity of proposed drawings.',
  title3_3: 'Monitoring Manufacturing process adopting cloud system',
  text3_3: 'Adopting the IOT, the manufacturing data can be readily captured in the system with real time tracking offering transparency at each and every phase during the manufacturing process.',
  title3_4: 'Online system management of quality',
  text3_4: 'Information on all packaging material are digitalized with the system enabling a“paperless”setting and are readily available online.  Each and every report are generated by the system ensuring reliability and conformity.',
}
export const about = {
  title1: '—  About Us  —',
  subtitle1: 'Company Profile',
  subtitle2: 'Awards',
  subtitle3: 'Milestones',
  text1: 'Worthpack is the leading internet digital platform packaging solution provider in China. We are committed to realize and meet the needs and requirements of the packaging supply chain by adopting digitalization and Internet technology.',
  text2: 'Embracing digitalization, Worthpack has an in depth understanding of the pain confronting the industrial players and seek to address these challenges pertaining to the supply chain in packaging by developing an innovative One Stop Cloud  based supply chain platform fully capitalizing on digitalization to realize our mission of “Packaging Made simpler”to meet our customers expectations.',
  text3:'Worthpack in administering a holistic supply chain strategy in packaging focus on the top tier, high value sector specifically in the  medical equipment, automotive and other major industrial sector, collating and digitalizing data from these key industrial players, continuously building up our data base to achieve standard and universal methodology in packaging designs, enhancing and augmenting further the digital platform for the ultimate realization of a robust, complete delivery and quality management system. ',
  text4:'The founder of our company in the supply chain within the packaging industry possesses resolute and  decisive vision coupled with an intimate understanding of this industry backed with rich and profound knowledge of the packaging landscape that  catalyze us from the outset of our company, to position our core competency driven by and embracing digitalization and implementing it extensively to the packaging supply chain. Today, Worthpack is the distinct leader in the space of digitalization  and a renowned supply chain packaging solution provider.',
  title1_1: 'Worthpack, Packaging Made Simpler',
  text1_1: 'Our mission purport to actualize“ Packaging  Made simpler”,by adopting an all encompassing digitalize approach to meet our set objectives.',
  mission: 'Our Mission: We Simplify Packaging',
  vision: 'Vision: Embracing digitalization, Worthpack  transformed the traditional packaging industry by utilizing a new web based ecosystem for packaging and redefined all business activities related to packaging and its supply chain,  setting and leading a new industry standards.'
}